<section class="modal">
  <div class="modal-header">
    <h3>
      {{ modalInfos?.title | uppercase }}
    </h3>
  </div>
  <div class="modal-content">
    <p>
      {{ modalInfos?.message }}
    </p>
    <br />
    <span>{{ modalInfos?.error }}</span>
  </div>
  <div class="modal-footer">
    <ng-container *ngIf="modalInfos">
      <analysis-buttons
        [id]="'btnFinish'"
        [label]="modalInfos?.button"
        [kind]="'primary'"
        [size]="'large'"
        (clicked)="closeDialog('completed')"
      ></analysis-buttons>
    </ng-container>
  </div>
</section>
